import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Phone, Building2 } from "lucide-react";

export default function Directory() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/directory").then((r) => setItems(r.data)).catch(() => {}); }, []);

    return (
        <div className="space-y-6" data-testid="directory-page">
            <div>
                <h1 className="font-heading text-3xl font-extrabold text-nhs-ink">Organisation Directory</h1>
                <p className="text-slate-500 mt-1">Key leads for EDI, HR, staff networks and speaking up.</p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {items.map((d) => (
                    <div key={d.id} className="bg-white rounded-lg border border-slate-200 shadow-sm p-6" data-testid={`directory-${d.id}`}>
                        <div className="h-12 w-12 rounded-full bg-nhs-blue text-white flex items-center justify-center font-heading font-bold text-lg">
                            {d.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}
                        </div>
                        <h3 className="font-heading font-semibold text-lg text-nhs-ink mt-4">{d.name}</h3>
                        <p className="text-sm text-nhs-blue font-medium">{d.role}</p>
                        <div className="mt-3 space-y-1.5 text-sm text-slate-600">
                            <p className="flex items-center gap-2"><Building2 className="h-4 w-4 text-slate-400" /> {d.department}</p>
                            <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-slate-400" /> {d.email}</p>
                            <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-slate-400" /> {d.phone}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
